module.exports = __webpack_public_path__ + "img/T5-C-rc_2.7b67e51f.png";